import { msg } from '@lingui/core/macro';
import { z } from 'zod';

import { flowSearchSchema } from '@/shared/flow/define-flow';
import { listSearchSchema } from '@/shared/patterns/list-search';

import { batchAssignmentListFilters } from './batch-assignment.list-filters';

// Leve de propósito: entra no arquivo da rota, que vai para o JS inicial (A01). Só zod, Lingui, filtros
// e `shared/patterns/list-search` direto (nunca o barril).

/** Caminho do menu (`router.tsx:1242`): é por ele que `screens.byPath` acha a tela. */
export const BATCH_ASSIGNMENT_LIST_PATH = '/ccb/cessoes';
export const BATCH_ASSIGNMENT_NEW_PATH = `${BATCH_ASSIGNMENT_LIST_PATH}/nova`;
export const batchAssignmentPath = (id: string) => `${BATCH_ASSIGNMENT_LIST_PATH}/${encodeURIComponent(id)}`;

/** Abas do legado, na ordem e com o rótulo da `TabBar` (`BatchAssignmentForm.tsx:53-74`, U44). */
export const BATCH_ASSIGNMENT_TABS = [
  { id: 'informacoes', label: msg`Informações`, icon: 'file-text' },
  { id: 'documentos', label: msg`Documentos`, icon: 'folder-cog' },
  { id: 'operacoes', label: msg`Operações`, icon: 'receipt-text' },
  { id: 'parcelas', label: msg`Parcelas`, icon: 'wallet' },
  { id: 'historico', label: msg`Histórico`, icon: 'badge-check' },
] as const;
export type BatchAssignmentTab = (typeof BATCH_ASSIGNMENT_TABS)[number]['id'];
export const BATCH_ASSIGNMENT_TAB_IDS = BATCH_ASSIGNMENT_TABS.map((tab) => tab.id) as [BatchAssignmentTab, ...BatchAssignmentTab[]];

/** Caminhos antigos das abas (`router.tsx:1271-1290`): hoje redirecionam para `?tab=` (S29). */
export const LEGACY_TAB_SEGMENTS = ['documentos', 'operacoes', 'parcelas', 'historico'] as const;

export const batchAssignmentListSearch = listSearchSchema(batchAssignmentListFilters.shape);
export type BatchAssignmentListSearch = z.infer<typeof batchAssignmentListSearch>;

/**
 * Filtros da aba Operações na URL. A declaração completa (`operationsFilters`) usa o status da
 * operação, que mora na porta do `credit-note` e não entra no JS inicial: aqui a rota só guarda as
 * chaves (texto ou lista), e a tela valida de novo com a declaração.
 */
const loose = z.union([z.string(), z.number(), z.array(z.union([z.string(), z.number()]))]).optional().catch(undefined);
export const OPERATIONS_FILTER_KEYS = ['creditNoteNo', 'status', 'initialDate', 'finalDate', 'maxValue', 'minValue', 'maxAssignmentValue', 'minAssignmentValue'] as const;

/** URL do detalhe: aba (a primeira não vai para a URL), página e tamanho da lista da aba e os filtros de Operações. */
export const batchAssignmentDetailSearch = listSearchSchema({
  tab: z.enum(BATCH_ASSIGNMENT_TAB_IDS).optional().catch(undefined),
  ...Object.fromEntries(OPERATIONS_FILTER_KEYS.map((key) => [key, loose])),
});
export type BatchAssignmentDetailSearch = z.infer<typeof batchAssignmentDetailSearch>;

/** Nova cessão: o passo do fluxo (`?passo=`). */
export const batchAssignmentNewSearch = flowSearchSchema();
